export function forumNextRoutes(guard) {
  const views = [
    ['/app/forum-next', 'ForumNext', 'recent'],
    ['/app/forum-next/section/:slug', 'ForumNextSection', 'section'],
    ['/app/forum-next/thread/:nid', 'ForumNextThread', 'thread'],
    ['/app/forum-next/search', 'ForumNextSearch', 'search'],
    ['/app/forum-next/new-thread', 'ForumNextCreate', 'create'],
    ['/app/forum-next/activity', 'ForumNextActivity', 'activity'],
    ['/app/forum-next/rules', 'ForumNextRules', 'rules'],
    ['/app/forum-next/admin/need-response', 'ForumNextPending', 'pending']
  ];
  return views.map(([path, name, forumView]) => ({ path, name,
    meta: { appShell: 'modern', contentLayout: 'document', documentTitle: forumView === 'rules' ? 'Normas del foro | Eurekers' : 'Foro | Eurekers', forumView },
    beforeEnter: guard,
    component: () => import('./views/ForumPage.vue')
  }));
}
